import { useMutation } from '@tanstack/react-query';
import { axiosLicensingInstance } from 'api/axios/licensing';
import { routes } from 'api/routes';

type StopCancelPlan = {
  subscription_id: number;
};

const remove = (values: StopCancelPlan) => {
  const { subscription_id } = values;
  return axiosLicensingInstance.delete(
    `${routes['v1_client']}/${subscription_id}/cancel`,
  );
};

const useStopSubscriptionCancellation = () => {
  return useMutation({
    mutationFn: remove,
  });
};

export default useStopSubscriptionCancellation;
